<template>
	<!-- star -->

	<div class="intdatapage_wrap">
		<nav2></nav2>
		<!-- 面包屑 -->
		<!--<div class="Crumbs">-->
			<!--<div>当前位置：产品案例><span>信息采集平台</span></div>-->
		<!--</div>-->
		<!--<div class="navWrap_center_img">-->
		<banner2 :bannerH="h1" :bannerImg="Img1"></banner2>
		<!--</div>-->


		<div class="container">
			<h1>产品优势</h1>
		<div class="grid-container">
			<div>
				<div class="grid-item">
					<div ><img src="../assets/img/intdata/1.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/intdata/2.png" alt="" /></div>
				</div>
			</div>
			<div>
				<div class="grid-item">
					<div><img src="../assets/img/intdata/3.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/intdata/4.png" alt="" /></div>
				</div>
			</div>
		</div>

		</div>
		<div class="middle">
			<h1>技术架构</h1>
			<img src="../assets/img/intdata/intdatabus.png" alt="" />
		</div>



		<!-- footer -->
		<footer2></footer2>
		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";
export default {
	name: "intdata",
	components: {
		footer2,
		nav2,
		banner2,
	},
	data() {
		return {
			// h1: "集团产业 · 集团产业",
			Img1: require("../assets/img/intdata/intdatabanner.png"),
		};
	},
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/

.container {
	position:relative;
	display: grid;
	background-color: #F8F9FC;
	width: 1920px;
	height: auto;
	/*justify-content: space-between;*/
	/*align-items: center;*/
}
@media screen and (max-device-width: 1900px) {
	.container {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.container {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.container {
		height: auto;
		width: 1336px;
	}
}
@media screen and (max-device-width: 1300px) {
	.container {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.container {
		height: auto;
		width: 2560px;
	}
}
.container img{
	width: 600px;
	height: auto;
	margin:0 auto;
	display: flex;
	justify-content: space-between;

}
.container h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	background-color: #F8F9FC;
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
}
.grid-container {
	display: flex;
	width: 100%;
	justify-content: center;
	background-color: #F8F9FC;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(2, 1fr);
}
.grid-item {
	/*background-color: #ccc;*/
	/*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);*/
	background-color: #F8F9FC;
	color: #fff;
	width: 600px;
	justify-content: center;
	/*text-align: center;*/
	/*padding: 30px 80px;*/
}
.middle{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	justify-content: center;
	/*margin-bottom:20px;*/
}
@media screen and (max-device-width: 1900px) {
	.middle {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
    .middle {
        height: auto;
        width: 1366px;
    }
}
@media screen and (max-device-width: 1300px) {
	.middle {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle {
		height: auto;
		width: 2560px;
	}
}
.middle img{
	width: 1200px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;


}
.middle h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	background-color: #F8F9FC;
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
}
.intdatapage_wrap {
	width: 100%;
	margin: 0 auto;
	height:  auto;
}

/* 特色 */
.Features {
	width: 100vw;
	height: 900px;
	background: #f8f8f8;
}
.Features_cont {
	width: 1200px;
	margin: 0 auto;
}
.Features_cont > h1 {
	text-align: center;
	padding-top: 60px;
	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #771b1b;
	line-height: 45px;
}
.Features_cont_item {
	margin-top: 17px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}

.Features_cont_item1 {
	text-align: center;
	margin-top: 24px;

	width: 384px;
	height: 325px;
	background: #ffffff;
	border-radius: 8px;
}
.Features_cont_item1 img {
	border: 1px dashed;
	margin-top: 54px;
}
.Features_cont_item1 p {
	margin-top: 26px;
}
.Features_cont_item1 span {
	padding: 18px 40px 0 40px;

	text-align: left;
	display: block;
	width: 304px;
	height: 96px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #da1616;
	line-height: 24px;
}
/* 面包屑 */
.Crumbs {
	width: 1200px;
	height: 46px;
	margin: 0 auto;
}
.Crumbs {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 17px;
}
.Crumbs div {
	line-height: 46px;
}
.Crumbs span {
	color: #000000;
}
/* 科技板块 */
.TechnologySector_cont {
	width: 1200px;
	height: 810px;
	margin: 0 auto;
	padding-top: 64px;
}
.TechnologySector_cont h1 {
	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 45px;
	text-align: center;
}
.TechnologySector_cont_bottom img {
	margin-top: 45px;
	float: right;
	width: 1000px;
	height: 520px;
}
.TechnologySector_cont_bottom_text {
	margin-top: -424px;
	float: left;
	width: 720px;
	height: 504px;
	background: #f8f8f8;
	z-index: 10;
}
.TechnologySector_cont_bottom_text div {
	margin-top: 36px;

	font-size: 16px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #333333;
	line-height: 32px;
}
.TechnologySector_cont_bottom_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 35px;
	margin-top: 24px;
}
.TechnologySector_cont_bottom_text_english {
	font-size: 70px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #f8f8f8;
	line-height: 98px;
}
/* 教育 */
.Education {
	width: 100vw;
	height: 1741px;
	background: #f8f8f8;
}
.Education_cont {
	width: 1200px;
	margin: 0 auto;
	padding-top: 91px;
}
.Education_cont h1 {
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 45px;
}
.Education_item {
	margin-top: 45px;
}
.Education_item1 {
	display: flex;
}
.Education_item_text {
	background: #ffffff;
	width: 740px;
	height: 340px;
}
.Education_item_text p {
	margin-top: 72px;
	margin-left: 86px;
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: red;
	line-height: 33px;
}
.Education_item_text span {
	width: 568px;
	height: 140px;
	margin-top: 24px;
	margin-left: 86px;

	display: inline-block;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 28px;
}
.Education_item1 {
	margin-bottom: 40px;
}
.Education_item1_block {
	width: 550px;
	display: flex;
	flex-wrap: wrap;
	margin-left: 86px;
}

.Education_item1_block .div3 {
	margin: 40px 24px 38px 0;
	line-height: 40px;
	text-align: center;
	width: 172px;
	height: 40px;
	background: #ffffff;
	border-radius: 4px;
	border: 1px solid #d7d7d7;
}
.Education_item1_block .div4 {
	margin-top: -10px;
}
.Education_item1_block .div5 {
	margin-top: -10px;
}

.Education_item1_block div {
	margin: 40px 24px 38px 0;
	line-height: 40px;

	text-align: center;
	width: 140px;
	height: 40px;
	background: #ffffff;
	border-radius: 4px;
	border: 1px solid #d7d7d7;
}
/* 城市 */
.Citi {
	width: 100vw;
	height: 883px;
	background-image: url("../assets/img/keji/蒙版.png");
}
.Citi_cont {
	width: 1200px;
	margin: 0 auto;
}
.Citi_cont > h1 {
	text-align: center;
	margin-top: 83px;

	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 45px;
}
.Citi_cont_p {
	text-align: center;
	margin-top: 40px;

	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 32px;
}
.Citi_cont_item {
	display: flex;
	justify-content: space-between;
	width: 1200px;
	margin-top: 64px;
}
.Citi_cont_item1 {
	width: 304px;
}

.Citi_cont_item1 p {
	margin: 24px 0;
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #23337f;
	line-height: 25px;
}
.Citi_cont_item1 span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}
/* 华为 */
.HuaWei {
	width: 100vw;
	height: 809px;
	background: #ffffff;
}
.HuaWei_cont {
	padding-top: 80px;
	width: 1200px;
	margin: 0 auto;
}
.HuaWei_cont > h1 {
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 45px;
}
.HuaWei_cont_p {
	margin-top: 60px;
	text-align: center;
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 22px;
}

.HuaWei_cont_item {
	display: flex;
	margin-top: 81px;
	margin-left: 150px;
}

.HuaWei_cont_item_img img {
	text-align: center;
	width: 320px;
	height: 326px;
}
.HuaWei_cont_item_l1 {
	text-align: right;

	margin-right: 41px;
}
.HuaWei_cont_item_l1 p {
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 33px;
	margin-left: 180px;
}
.HuaWei_cont_item_l1 span {
	float: right;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
}
.HuaWei_cont_item_l2 {
	text-align: right;
	margin-right: 41px;

	margin-top: 90px;
}
.HuaWei_cont_item_l2 p {
	margin-left: 180px;
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 33px;
	margin-left: 180px;
}
.HuaWei_cont_item_l2 span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
}
.HuaWei_cont_item_r {
	margin-left: 16px;
}
.HuaWei_cont_item_r1 p {
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 33px;
}
.HuaWei_cont_item_r1 span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
}
.HuaWei_cont_item_r2 {
	margin-top: 90px;
}
.HuaWei_cont_item_r2 p {
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 33px;
}
.HuaWei_cont_item_r2 span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
}
.HuaWei_cont_item_c {
	margin-top: 41px;
	text-align: center;
}
.HuaWei_cont_item_c p {
	font-size: 24px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 33px;
}
.HuaWei_cont_item_c span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
}
/* 集团产业 */
.GroupIndustry {
	width: 100vw;
	height: 800px;
	background: #ffffff;
}
.GroupIndustry_cont {
	width: 1200px;
	margin: 0 auto;

	display: flex;
	justify-content: space-between;
}
.GroupIndustry_cont_left_title {
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #444444;
	line-height: 50px;
	margin: 84px 0 40px 0;
}
.GroupIndustry_cont_left_img_f {
	width: 793px;

	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
.GroupIndustry_cont_left_img {
	margin-bottom: 24px;

	position: relative;
}
.GroupIndustry_cont_left_img img:first-child {
	width: 384px;
	height: 261px;
	background: linear-gradient(180deg, rgba(0, 100, 255, 0) 0%, #000b6e 100%);
}
.GroupIndustry_cont_left_img2 {
	position: absolute;
	left: 0;
	bottom: 0;
}

.GroupIndustry_cont_left_text {
	position: absolute;
	left: 32px;
	bottom: 18px;
}
.GroupIndustry_cont_left_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
	margin-top: 10px;
}
.GroupIndustry_cont_left_text span {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
}
.GroupIndustry_cont_right {
	position: relative;
	margin-top: 98px;
}
.GroupIndustry_cont_right_title {
	float: right;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 22px;
	margin-bottom: 54px;
}

.GroupIndustry_cont_right_img {
	width: 384px;
	height: 546px;
}
.GroupIndustry_cont_right_img2 {
	position: absolute;
	bottom: 24px;
}
.GroupIndustry_cont_right_text {
	position: absolute;
	left: 45px;
	bottom: 45px;
}
.GroupIndustry_cont_right_text p {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	line-height: 33px;
}
.GroupIndustry_cont_right_text span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
}
</style>
